import cn from 'classnames';

import type { ApprovalStatus } from 'models/ApprovalWorkFlow';

interface BadgeStyleParams {
  color: string;
}

interface Badge {
  label: string;
  style: BadgeStyleParams;
}

const approvalStatuses: Record<ApprovalStatus, Badge> = {
  completed: {
    label: 'Approved',
    style: {
      color: 'bg-status-completed'
    }
  },
  waiting_review: {
    label: 'Pending Approval',
    style: {
      color: 'bg-status-pending'
    }
  },
  rejected: {
    label: 'Declined',
    style: {
      color: 'bg-status-negative'
    }
  }
};

interface ApprovalBadgeProps {
  status: ApprovalStatus;
}

export const ApprovalBadge = ({ status }: ApprovalBadgeProps) => {
  const approvalStatus = approvalStatuses[status];

  return (
    <span
      className={cn(
        'w-fit max-w-full gap-1 overflow-hidden truncate rounded-2xl px-2 py-1 text-sm leading-4',
        `${approvalStatus?.style.color}`
      )}
    >
      {approvalStatus?.label ?? status}
    </span>
  );
};
